import * as d3 from 'd3'
import Tooltip from './Tooltip'
import { getHtmlElementSize } from '../d3Utils'
import {
  RenderDatum,
  TooltipParams,
  TooltipSourceDatum,
  TooltipRenderDatum
} from './types'
import { DEFAULT_TOOLTIP_FOLLIWING } from './defaults'

export type TooltipFollowingParams = TooltipParams & {
  insideBoxMode: boolean;
}

export type TooltipFollowingSourceDatum = TooltipSourceDatum

export type TooltipFollowingRenderDatum = RenderDatum & TooltipRenderDatum & {
  _sourceData: TooltipFollowingSourceDatum;
}


export default class TooltipFollowing extends Tooltip {
  private tooltipSelection: (d3.Selection<HTMLElement, any, any, unknown> | undefined) = undefined

  constructor (selection: d3.Selection<any, unknown, null, undefined>, params?: TooltipFollowingParams) {
    super(selection, params)

    this.params = {
      ...this.params,
      ...params
    }

    const insideBoxMode = params?.insideBoxMode ?? true
    if (insideBoxMode === true) {
      this.renderTooltip = this.renderInsideBox
    } else {
      this.renderTooltip = this.renderDefault
    }
  }

  // 依座標顯示
  private renderDefault (renderData: Array<TooltipFollowingRenderDatum>) {
    const update = d3.select('body')
      .selectAll<HTMLElement, TooltipFollowingRenderDatum>('.bpchat___tooltip')
      .data(renderData)
    const enter = update.enter()
      .append('div')
      .classed('bpchat___tooltip', true)
      .call(this.setTooltipStyle)
    this.tooltipSelection = update.merge(enter as any)
      .style('position', 'fixed')
      .style('z-index', 10000)
      .style('left', (d) => {
        return `${d.x + this.params.offsetX!}px`
      })
      .style('top', (d) => {
        return `${d.y + this.params.offsetY!}px`
      })
      .html((d) => d.contentHtml)
    update.exit()
      // .transition()
      // .style('opacity', 0)
      .remove()
  }

  // 座標限制在元素內
  private renderInsideBox (renderData: Array<TooltipFollowingRenderDatum>) {
    const containerSize = getHtmlElementSize(this.selection)
    const tooltipSize = (this.tooltipSelection?.node()) ? getHtmlElementSize(this.tooltipSelection!) : { width: 0, height: 0 }
    const minX = containerSize.x
    const maxX = containerSize.x + containerSize.width - tooltipSize.width
    const minY = containerSize.y
    const maxY = containerSize.y + containerSize.height - tooltipSize.height

    const update = d3.select('body')
      .selectAll<HTMLElement, TooltipFollowingRenderDatum>('.bpchat___tooltip')
      .data(renderData)
    const enter = update.enter()
      .append('div')
      .classed('bpchat___tooltip', true)
      .call(this.setTooltipStyle)
    this.tooltipSelection = update.merge(enter as any)
      .style('position', 'fixed')
      .style('z-index', 10000)
      .style('left', (d) => {
        const x = d.x! + this.params.offsetX!
        if (x < minX) {
          return `${minX}px`
        } else if (x > maxX) {
          return `${maxX}px`
        }
        return `${x}px`
      })
      .style('top', (d) => {
        const y = d.y! + this.params.offsetY!
        if (y < minY) {
          return `${minY}px`
        } else if (y > maxY) {
          return `${maxY}px`
        }
        return `${y}px`
      })
      .html((d) => d.contentHtml)
    update.exit()
      // .transition()
      // .style('opacity', 0)
      .remove()
  }

  protected renderTooltip (data?: Array<(TooltipFollowingRenderDatum)>) {}

  public remove () {
    if (this.tooltipSelection) {
      this.tooltipSelection!
        // .transition()
        // .style('opacity', 0)
        .remove()
        // .on('end', () => {
        //   this.renderData.contentHtml = ''
        // })
    }
  }
}

